import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "leads-status-table" }
const _hoisted_2 = { class: "leads-status-table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pill = _resolveComponent("pill")!
  const _component_hadrianModal = _resolveComponent("hadrianModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_hadrianModal, {
      ref: "modalRef",
      class: "leads-status-legend",
      leftButtonText: _ctx.$t('labels.close'),
      onLeftButtonClick: _ctx.cancel,
      leftButtonClass: "leads-status-legend__modal-footer-button",
      hideRightButton: "",
      hideHeader: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("table", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "leads-status-table-status" }, "LEAD STATUS"),
              _createElementVNode("th", null, [
                _createElementVNode("hr")
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leadStatuses, (status) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: status.leadStatusId
              }, [
                _createElementVNode("td", null, [
                  _createVNode(_component_pill, {
                    round: "",
                    theme: _ctx.getPillTheme(status.leadStatusId),
                    class: "leads__status"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(status.label), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["theme"])
                ]),
                _createElementVNode("td", null, _toDisplayString(status.description), 1)
              ]))
            }), 128))
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("table", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", { class: "leads-status-table-status" }, "REPORT STATUS"),
              _createElementVNode("th", null, [
                _createElementVNode("hr")
              ])
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportStatuses, (status) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: status.leadStatusId
              }, [
                _createElementVNode("td", null, [
                  _createVNode(_component_pill, {
                    round: "",
                    theme: _ctx.getPillTheme(status.leadStatusId),
                    class: "leads__status"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(status.label), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["theme"])
                ]),
                _createElementVNode("td", null, _toDisplayString(status.description), 1)
              ]))
            }), 128))
          ])
        ])
      ], undefined, true),
      _: 1
    }, 8, ["leftButtonText", "onLeftButtonClick"])
  ]))
}